import React, {useEffect, useState} from "react";
import {Button, Typography} from "@mui/material";
import css_self from "./css/Pages.module.scss";
import enterpriseObjectClassFactory from "../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../eoec/eo/EnterpriseObject";
import ProjectMilestoneSessionTableApplet from "../eoec/applet/impl/Session/ProjectMilestoneSessionTableApplet";
import ProjectMilestoneAuditHistoryTableApplet from "../eoec/applet/impl/Session/ProjectMilestoneAuditHistoryTableApplet";



type MenuSelection = {id: string, target: EventTarget & HTMLButtonElement, option: string | null}

export default function MyEnlil() {
    const [viewOption, setViewOption] = React.useState<string | null>("Settings");
    const [projectMilestoneSessionEnterpriseObject] = useState(enterpriseObjectClassFactory("ProjectMilestoneSession") as EnterpriseObject);

    useEffect(() => {

        return () => {
        }
    });

    let menus = (
        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
            <div style={{paddingTop: "10px", marginLeft: "30px"}}>
                <div style={viewOption === "Settings" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}>
                    <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                        setViewOption("Settings")
                    }}>Settings</Button>
                </div>
            </div>
            <div style={{paddingTop: "10px", marginLeft: "30px"}}>
                <div style={viewOption === "Audit History" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}>
                    <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                        setViewOption("Audit History")
                    }}>Audit History</Button>
                </div>
            </div>
        </div>
    );

    let auditHistory = (
        <div style={{display: "flex", flexDirection: "column", backgroundColor: "#FFFFFF", height: "100vh", paddingRight: "60px"}}>
            <div style={{paddingLeft: "30px", paddingTop: "30px", width: "100%"}}>
                <ProjectMilestoneSessionTableApplet enterpriseComponent={projectMilestoneSessionEnterpriseObject?.getEnterpriseComponent("ProjectMilestoneSession")} PageSize={{
                    "default": 5,
                }}/>
            </div>
            <div style={{paddingLeft: "30px", paddingTop: "30px", width: "100%"}}>
                <ProjectMilestoneAuditHistoryTableApplet enterpriseComponent={projectMilestoneSessionEnterpriseObject?.getEnterpriseComponent("ProjectMilestoneAuditHistory")} PageSize={{
                    "default": 20,
                }}/>
            </div>
        </div>
    );


    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>My Enlil</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                </div>
            </div>
            {menus}
            {viewOption === "Audit History" ? (auditHistory) : null}
        </div>
    );
}